// extracted by mini-css-extract-plugin
export default {"container":"Home_container__I166A","image":"Home_image__w18uf","description":"Home_description__aVWMn"};